import { fromJS, Record } from 'immutable';

export const instancesRecord = new Record({
  byId: fromJS({}),
  allIds: fromJS([]),
  byProjectId: fromJS({})
});

export default instancesRecord();
